<ng-container *ngIf="hasProducts">
  <div class="featured-products">
    <div class="featured-products-wrapper">
      <h4>{{ 'featured-products.title' | translate }}</h4>
      <app-layout-options
          class="sm-hidden"
          [currentLayoutType]="currentLayoutType"
          (selected)="selectLayoutOption($event)">
      </app-layout-options>
    </div>
    <ng-container ngProjectAs="[slot][content]">
      <div [appLoadingAnimation]="!isLoaded">
        <ng-container *ngIf="currentLayoutType === 'grid'">
          <app-slick-carousel 
              class="carousel-grid" 
              [config]="slideConfigHorizontal">
            <div
                class="col-grid"
                appSlickItem
                *ngFor="let product of featuredProductsWithPricesAndImages">
              <div class="card" [ngClass]="{'in-progress': isItemInProgress(product.attributes.sku)}">
                <app-access-control [notForViewer]="true">
                  <ng-container ngProjectAs="[slot][nonViewerContent]">
                    <app-sticker
                        [product]="product"
                        [labels]="labels"
                        [prices]="product.attributes.prices">
                    </app-sticker>
                    <app-add-to-wishlist
                        [ngClass]="'add-to-wishlist-container'"
                        [wishlists]="wishlists"
                        [maxLength]="3"
                        [sku]="product.attributes?.concreteSku[0]"
                        [productName]="product.attributes?.name"
                        [productKeywords]="product.attributes?.keywords"
                        [addNewModalActive]="addNewModalActive"
                        (createNew)="addNewModalActive = true">
                    </app-add-to-wishlist>
                  </ng-container>
                </app-access-control>
                <div class="card-content">
                  <div class="card__image" [title]="product.attributes.name || product.attributes.sku">
                    <a [routerLink]="['/product/', product.attributes.sku]"
                      [title]="product.attributes.name || product.attributes.sku">
                      <div class="aspect-ratio-16x9 aspect-ratio--fill">
                        <ng-container *ngIf="product.attributes.externalUrlSmall">
                          <img class="fit-card" alt="{{product.attributes.name}}"
                              [src]="product.attributes.externalUrlSmall"/>
                        </ng-container>
                        <ng-container *ngIf="!product.attributes.externalUrlSmall">
                          <img class="fit-card" alt="{{product.attributes.name}}" [src]="defaultImg"/>
                        </ng-container>
                      </div>
                    </a>
                  </div>
                  <div class="card__body">
                    <h2 class="card__title">
                      <a [routerLink]="['/product/', product.attributes.sku]"
                        [title]="product.attributes.name || product.attributes.sku">
                        {{product.attributes.name || product.attributes.sku}}
                      </a>
                    </h2>
                    <app-access-control>
                      <ng-container ngProjectAs="[slot][content]">
                        <div *ngIf="product.attributes.price | shouldDisplayPrice" class="fit-price">
                          <p class="card__price">
                            {{ product.attributes.price | currency: priceUtils.getStoreCurrencyCode() }}
                            <ng-container *ngIf="hasGuestPrice(product)">
                              <small
                                  class="product__description__price-alternative">
                                {{ getGuestPrice(product) | currency: priceUtils.getStoreCurrencyCode() }}
                              </small>
                            </ng-container>
                          </p>
                        </div>
                        <app-access-control [notForViewer]="true">
                          <ng-container ngProjectAs="[slot][nonViewerContent]">
                            <button
                                appDebounceClick
                                class="button button--link add-to-cart"
                                [debounceTime]="300"
                                (click)="addToCart({sku: product.attributes.sku, name: product.attributes.name || product.attributes.sku})"
                                [disabled]="isAddToCartBtnDisabled()">
                              <span class="icons-group">
                                <span class="icon-basket"></span>
                              </span>
                              <span>
                                {{ 'app-product-page.add-to-cart' | translate }}
                              </span>
                            </button>
                          </ng-container>
                        </app-access-control>
                      </ng-container>
                    </app-access-control>
                  </div>
                </div>
                <div class="loader__overlay">
                  <span class="loading-animation"></span>
                </div>
              </div>
            </div>
          </app-slick-carousel>
        </ng-container>

        <ng-container *ngIf="currentLayoutType === 'list'">
          <app-slick-carousel class="carousel-list"
                              [config]="slideConfigVertical">
            <div appSlickItem *ngFor="let product of featuredProductsWithPricesAndImages" class="row col-12">
              <app-access-control [notForViewer]="true">
                <ng-container ngProjectAs="[slot][nonViewerContent]">
                  <app-sticker
                      [product]="product"
                      [labels]="labels"
                      [prices]="product.attributes.prices">
                  </app-sticker>
                  <app-add-to-wishlist
                      [ngClass]="'add-to-wishlist-container'"
                      [wishlists]="wishlists"
                      [sku]="product.attributes?.concreteSku[0]"
                      [productName]="product.attributes?.name"
                      [productKeywords]="product.attributes?.keywords"
                      [addNewModalActive]="addNewModalActive"
                      (createNew)="addNewModalActive = true">
                  </app-add-to-wishlist>
                </ng-container>
              </app-access-control>
              <div class="card" [ngClass]="{'in-progress': isItemInProgress(product.attributes.sku)}">
                <div class="card-content">
                  <div class="card__image">
                    <a [routerLink]="['/product/', product.attributes.sku]"
                      [title]="product.attributes.name || product.attributes.sku">
                      <div class="aspect-ratio-16x9 aspect-ratio--fill">
                        <ng-container *ngIf="product.attributes.externalUrlSmall">
                          <img class="fit-card" alt="{{product.attributes.name}}"
                              [src]="product.attributes.externalUrlSmall"/>
                        </ng-container>
                        <ng-container *ngIf="!product.attributes.externalUrlSmall">
                          <img class="fit-card" alt="{{product.attributes.name}}" [src]="defaultImg"/>
                        </ng-container>
                      </div>
                    </a>
                  </div>
                  <div class="card__body">
                    <h2 class="card__title">
                      <a
                          [routerLink]="['/product/', product.attributes.sku]"
                          [title]="product.attributes.name || product.attributes.sku">
                        {{product.attributes.name || product.attributes.sku}}
                      </a>
                    </h2>
                    <app-access-control>
                      <ng-container ngProjectAs="[slot][content]">
                        <div *ngIf="product.attributes.price | shouldDisplayPrice">
                          <p class="card__price">
                            {{ product.attributes.price | currency: priceUtils.getStoreCurrencyCode() }}
                            <ng-container *ngIf="hasGuestPrice(product)">
                              <small
                                  class="product__description__price-alternative">
                                {{ getGuestPrice(product) | currency: priceUtils.getStoreCurrencyCode() }}
                              </small>
                            </ng-container>
                          </p>
                        </div>
                        <app-access-control [notForViewer]="true">
                          <ng-container ngProjectAs="[slot][nonViewerContent]">
                            <button
                                appDebounceClick
                                class="button button--link add-to-cart"
                                [debounceTime]="300"
                                (debounceClick)="addToCart({sku: product.attributes.sku, name: product.attributes.name || product.attributes.sku})"
                                [disabled]="isAddToCartBtnDisabled()">
                              <span class="icons-group">
                                <span class="icon-basket"></span>
                              </span>
                              <span>
                                {{ 'app-product-page.add-to-cart' | translate }}
                              </span>
                            </button>
                          </ng-container>
                        </app-access-control>
                      </ng-container>
                    </app-access-control>
                  </div>
                </div>
                <div class="loader__overlay">
                  <span class="loading-animation"></span>
                </div>
              </div>
            </div>
          </app-slick-carousel>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <app-add-new-wishlist
      [showModal]="addNewModalActive"
      (closeModal)="addNewModalActive = false"
      (created)="wishlistCreated($event)">
  </app-add-new-wishlist>
  <app-add-item-modal
      [showModal]="addItemToCartModalActive"
      (closeModal)="addItemToCartModalActive = false"
      [items]="itemToAdd"
      [currentCartId]="currentCartId">
  </app-add-item-modal>
  <app-modal-confirm
      [type]="iconType.WARNING"
      modalTitle="{{ 'catalog.select-equipment-modal.title' | translate }}"
      notifyText="{{ 'catalog.select-equipment-modal.text' | translate }}"
      cancelBtnText="{{ 'catalog.select-equipment-modal.cancel-btn' | translate }}"
      primaryBtnText="{{ 'catalog.select-equipment-modal.submit-btn' | translate }}"
      [showModalConfirm]="showModalSelectEquipment"
      (closeModalConfirm)="showModalSelectEquipment = false"
      (primaryActionConfirm)="selectEquipment()">
  </app-modal-confirm>
</ng-container>
